import { Delete20Regular, Edit20Regular } from '@fluentui/react-icons';
import { Holiday } from '@mnspro-cloud/services';
import moment from 'moment-timezone';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../Button';
import { Flex } from '../../../../Flex';
import { Text } from '../../../../Text';
import './HolidayComponent.module.css';

export interface HolidayComponentProps extends Holiday {
  isOver?: boolean;
  editClicked?: () => void;
  deleteClicked?: () => void;
}

export const HolidayComponent: FC<HolidayComponentProps> = (props) => {
  const { name, start, end, isOver, editClicked, deleteClicked } = props;
  const { t } = useTranslation();
  const fontStyle: string[] = [];

  isOver ? fontStyle.push('isOver') : null;

  const fontStyleClassNames = fontStyle.join(' ');
  return (
    <Flex gap="0.5rem" className="holidayComponent" align="center" data-testid="holidayComponent">
      <Flex direction="column" gap="0.5rem" fill align="center">
        <Text size="lg" weight="bold" className={fontStyleClassNames}>
          {name}
        </Text>
        <Flex gap="0.5rem">
          <Text className={fontStyleClassNames}>{moment(start).format('DD.MM.YYYY')}</Text>
          <Text>-</Text>
          <Text className={fontStyleClassNames}>{moment(end).format('DD.MM.YYYY')}</Text>
        </Flex>
      </Flex>
      <Flex direction="column">
        <Button
          appearance="transparent"
          icon={<Edit20Regular />}
          onClick={editClicked}
          data-testid="sideMenuEditButton"
          aria-label={t('settings:classbook:holidays:edit_holiday_a11y', { defaultValue: 'Ferien bearbeiten' })}
        />
        <Button
          appearance="transparent"
          icon={<Delete20Regular />}
          onClick={deleteClicked}
          data-testid="sideMenuDeleteButton"
          aria-label={t('settings:classbook:holidays:delete_holiday_a11y', { defaultValue: 'Ferien löschen' })}
        />
      </Flex>
    </Flex>
  );
};
